export const SHIP_TO_EMERGENCY_ORDERS_MODAL = "SHIP_TO_EMERGENCY_ORDERS_MODAL";
export const SHIP_TO_REFUSE_EMERGENCY_ORDERS_MODAL = "SHIP_TO_REFUSE_EMERGENCY_ORDERS_MODAL";

export const SHIP_TO_EMERGENCY_ORDERS_MODAL_WIDTH = "670px";

export const EMERGENCY_ORDER_FORM_APPROVE_FIELD = "approveField";
